<script lang="typescript">
	import type { Role, Texts, Type } from "./instachat";
	import type { JitsiSettings } from "./jitsi";
	import Showcase from "./Showcase.svelte";
	import { clearError, error, state } from "./stores";
	import Chat from "./Chat.svelte";

	export let role: Role;
	export let type: Type;
	export let texts: Texts;
	export let jitsi: JitsiSettings;
</script>

{#if $error}
	<div class="error">
		<div class="text">
			{error}
		</div>
		<div>
			<button on:click={() => clearError()}>Ok</button>
		</div>
	</div>
{/if}

{#if $state === "UNKNOWN"}
	<div>Ladataan vanhempainvartti...</div>
{:else if type === "showcase"}
	<Showcase texts={texts.showcase} />
{:else}
	<Chat {jitsi} {role} texts={texts.chat} />
{/if}

<style>
	.error {
		border: 1px solid red;
	}
</style>
